import Typography from '@mui/material/Typography';

interface Props {
  children: React.ReactNode;
  title?: string;
  className?: string;
}

/** Card-like section with rounded border and surface background. */
export default function CardSection({ children, title, className = '' }: Props) {
  return (
    <div className={`rounded-lg border border-surface bg-surface p-4 ${className}`.trim()}>
      {title && (
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
}
